import React from 'react';
import { Button, DialogActions } from '@material-ui/core';
import { space, color } from './tokens';

interface Props {
    onCancel?: () => void;
    onSubmit?: () => void;
    cancelLabel?: string;
    submitLabel?: string;
    submitDisabled?: boolean;
    submitting?: boolean;
    danger?: boolean;
    extraLeft?: React.ReactNode;
    submitType?: 'button' | 'submit';
}

const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: space.sm,
    paddingTop: space.md,
    paddingBottom: space.md,
    paddingLeft: space.lg,
    paddingRight: space.lg,
    borderTop: `1px solid ${color.border.subtle}`,
    margin: 0
};

const leftSlotStyle: React.CSSProperties = {
    marginRight: 'auto'
};

export const HarmonisedModalActions: React.FC<Props> = ({
    onCancel,
    onSubmit,
    cancelLabel = 'Cancel',
    submitLabel = 'Save',
    submitDisabled = false,
    submitting = false,
    danger = false,
    extraLeft,
    submitType = 'button'
}) => {
    return (
        <DialogActions style={containerStyle}>
            {extraLeft ? <div style={leftSlotStyle}>{extraLeft}</div> : null}
            {onCancel ? (
                <Button
                    onClick={onCancel}
                    color="default"
                    variant="text"
                    disabled={submitting}
                    size="small"
                >
                    {cancelLabel}
                </Button>
            ) : null}
            {onSubmit ? (
                <Button
                    onClick={onSubmit}
                    type={submitType}
                    color={danger ? 'secondary' : 'primary'}
                    variant="contained"
                    disabled={submitDisabled || submitting}
                    disableElevation
                    size="small"
                >
                    {submitting ? 'Working…' : submitLabel}
                </Button>
            ) : null}
        </DialogActions>
    );
};

export default HarmonisedModalActions;
